import { render, staticRenderFns } from "./studentsRoute.vue?vue&type=template&id=157fb10f&"
import script from "./studentsRoute.vue?vue&type=script&lang=js&"
export * from "./studentsRoute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports